(() => {
  if (window.__rebeloCartCheckoutHandoff) return;
  window.__rebeloCartCheckoutHandoff = true;
  document.documentElement.dataset.rebeloCheckoutHandoff = 'active';

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  const checkoutPath = /\/(?:checkouts?|checkout)(?:\/|$)/i;
  const checkoutHost = /(?:shiprocket|fastrr|pickrr)/i;
  let shiprocketTapActive = false;
  let tapResetTimer;

  const isCheckoutDestination = (rawUrl) => {
    if (!rawUrl) return false;
    try {
      const url = new URL(String(rawUrl), window.location.href);
      return checkoutPath.test(url.pathname) || checkoutHost.test(url.hostname);
    } catch (_error) {
      return false;
    }
  };

  const findControl = (node) => {
    if (!(node instanceof Element)) return null;
    return node.closest('a, button, [role="button"], input[type="submit"]');
  };

  const isShiprocketControl = (control) => {
    if (!control) return false;
    const label = [
      control.textContent,
      control.getAttribute('aria-label'),
      control.getAttribute('title'),
      control.value
    ].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();

    if (!/(?:buy now|check ?out)/i.test(label)) return false;

    const integrationRoot = control.closest(
      '[class*="shiprocket" i], [id*="shiprocket" i], [class*="fastrr" i], [id*="fastrr" i], [class*="pickrr" i], [id*="pickrr" i]'
    );
    const nearbyText = (integrationRoot || control.parentElement)?.textContent || '';

    return /(?:shiprocket|fastrr|pickrr|powered by)/i.test(nearbyText) || /buy now/i.test(label);
  };

  const activateShiprocketTap = (event) => {
    if (!isMobile()) return;
    const control = findControl(event.target);
    if (!isShiprocketControl(control)) return;

    shiprocketTapActive = true;
    window.clearTimeout(tapResetTimer);
    tapResetTimer = window.setTimeout(() => {
      shiprocketTapActive = false;
    }, 5000);

    if (control instanceof HTMLAnchorElement && control.target.toLowerCase() === '_blank') {
      control.target = '_self';
    }

    const form = control.closest('form');
    if (form?.target?.toLowerCase() === '_blank') {
      form.target = '_self';
    }
  };

  document.addEventListener('pointerdown', activateShiprocketTap, true);
  document.addEventListener('click', activateShiprocketTap, true);
  document.addEventListener('submit', (event) => {
    if (!isMobile()) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.target.toLowerCase() === '_blank' && (shiprocketTapActive || isCheckoutDestination(form.action))) {
      form.target = '_self';
    }
  }, true);

  const nativeWindowOpen = window.open;
  window.open = function rebeloCartWindowOpen(url, target, features) {
    if (isMobile() && (shiprocketTapActive || isCheckoutDestination(url))) {
      if (url && String(url).toLowerCase() !== 'about:blank') {
        window.location.assign(new URL(String(url), window.location.href).href);
      }
      return window;
    }
    return typeof nativeWindowOpen === 'function'
      ? nativeWindowOpen.call(window, url, target, features)
      : null;
  };

  const normalizeCheckoutLinks = (root = document) => {
    root.querySelectorAll?.('a[target="_blank"]').forEach((link) => {
      if (isCheckoutDestination(link.href)) link.target = '_self';
    });
  };

  normalizeCheckoutLinks();
  new MutationObserver((mutations) => {
    if (!isMobile()) return;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) normalizeCheckoutLinks(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();